import React from 'react';
import PropTypes from 'prop-types';

const getHref = (url) => (url instanceof URL ? url.href : url);

export default function TimetablesInfoCard({
  title, description, linkLabel, url,
}) {
  return (
    <div className="at-xxs:col-span-4 at-sm:col-span-6 at-md:col-span-6 at-lg:col-span-6" data-testid="timetables-info-card">
      <at-info-card has-hero-image="false">
        <h5 slot="title">{title}</h5>
        <at-text-block slot="description">{description}</at-text-block>
        <at-icon-link slot="link" href={getHref(url)} label={linkLabel} />
      </at-info-card>
    </div>
  );
}

TimetablesInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(URL)]).isRequired,
};
